import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { CategoryType, DeviceAssignmentHistoryItemDto } from '@rocksoft/settings-sdk';

export function isChildCategoryType(categoryType: CategoryType): boolean {
  return !['Brand', 'Location', 'Unavailable'].includes(categoryType);
}

export function selectIdFromHistory(history: DeviceAssignmentHistory) {
  return history.deviceId;
}

export const adapter: EntityAdapter<DeviceAssignmentHistory> = createEntityAdapter<DeviceAssignmentHistory>({
  selectId: selectIdFromHistory,
});

export interface DeviceAssignmentHistory {
  deviceId: string;
  history: DeviceAssignmentHistoryItemDto[];
}

export type DeviceAssignmentHistoryState = EntityState<DeviceAssignmentHistory>;

export const initialState: DeviceAssignmentHistoryState = adapter.getInitialState();
